"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createDeal = createDeal;
exports.createDealWithAssociations = createDealWithAssociations;
exports.deleteDeal = deleteDeal;
exports.fetch = fetch;
exports.updateDealProperties = updateDealProperties;

var _immutable = require("immutable");

var _user = _interopRequireDefault(require("hub-http-shims/UserDataJS/user"));

var _PropertySourceTypes = require("customer-data-objects/property/PropertySourceTypes");

var _DealRecord = _interopRequireDefault(require("customer-data-objects/deal/DealRecord"));

var _ImmutableAPI = require("crm_data/api/ImmutableAPI");

var _sharedAPI = require("crm_data/inboundDB/sharedAPI");

var _MetaAPI = require("crm_data/meta/MetaAPI");

var _MetaProducers = require("crm_data/meta/MetaProducers");

var _ImmutableModel = require("customer-data-objects/model/ImmutableModel");

var _HTTPVerbs = require("crm_data/constants/HTTPVerbs");

var _DealsAPIQuery = require("./DealsAPIQuery");

var contactsCrmUiSourceHeaders = {
  'X-Properties-Source': _PropertySourceTypes.CONTACTS,
  'X-Properties-SourceId': _PropertySourceTypes.CRM_UI
};
var BASE_URI = 'deals/v1/deal';
var BATCH_URI = BASE_URI + "/batch";

var toUri = function toUri(queryStr) {
  return BATCH_URI + "?" + queryStr;
};

function createDeal(payload) {
  return (0, _ImmutableAPI.send)({
    headers: contactsCrmUiSourceHeaders,
    type: _HTTPVerbs.POST
  }, BASE_URI, payload, function (result) {
    return (0, _immutable.Map)().set(result.dealId, _DealRecord.default.fromJS(result));
  });
}

function createDealWithAssociations(_ref) {
  var propertyValues = _ref.propertyValues,
      requestedAssociatedObjects = _ref.requestedAssociatedObjects;
  return (0, _ImmutableAPI.send)({
    headers: contactsCrmUiSourceHeaders,
    type: _HTTPVerbs.POST
  }, 'inbounddb-objects/v1/create-and-bulk-associate', {
    createObjectType: _MetaProducers.DEAL,
    propertyValues: propertyValues,
    requestedAssociatedObjects: requestedAssociatedObjects
  }, function (result) {
    result['dealId'] = result.objectId;
    return (0, _immutable.Map)().set(result.dealId, _DealRecord.default.fromJS(result));
  });
}

function deleteDeal(dealId) {
  return (0, _sharedAPI.del)(BASE_URI + "/" + dealId);
}

function fetch(ids) {
  var fallback = function fallback() {
    return (0, _ImmutableAPI.get)(toUri((0, _DealsAPIQuery.byIdsStr)(ids)));
  };

  var parseItems = function parseItems(result) {
    return result.reduce(function (coll, val) {
      var deal = _DealRecord.default.fromJS(val);

      var dealId = (0, _ImmutableModel.getId)(deal);
      return coll.set(String(dealId), deal);
    }, (0, _immutable.Map)());
  };

  if (ids.size === 1) {
    var objectId = ids.first();
    return (0, _MetaAPI.queueFetch)(_MetaProducers.DEAL, fallback, {
      dealId: parseInt(objectId, 10)
    }, parseItems);
  }

  return fallback().then(parseItems);
}

function updateDealProperties(deal, propertyUpdates) {
  var dealId = deal.get('dealId');
  return (0, _ImmutableAPI.send)({
    headers: contactsCrmUiSourceHeaders,
    type: _HTTPVerbs.PUT
  }, BASE_URI + "/" + dealId, {
    dealId: dealId,
    properties: propertyUpdates.reduce(function (acc, value, name) {
      acc.push({
        name: name,
        value: value,
        source: _PropertySourceTypes.CRM_UI,
        sourceId: _user.default.get().get('email')
      });
      return acc;
    }, [])
  }, _DealRecord.default.fromJS);
}